// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gy-0";
export var actionModalContentContainer = "_gy-1";
export var createTagButton = "_gy-2";
export var footerContainer = "_gy-7";
export var fullWidthDivider = "_gy-3";
export var hasCreateTagButton = "_gy-4";
export var noCreateTagButton = "_gy-5";
export var tagsContainer = "_gy-6";
export var tagsModalContentContainer = "_gy-8";